import _extends from "@babel/runtime/helpers/extends";
import { Input, Label, FormGroup } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { kebabCase } from 'lodash';
import BreadcrumbsBack from './breadcrumbsBack';
import Icon from '../containers/icon';
export default class TieredSelect extends Component {
  constructor(props) {
    super(props);

    // keep track of slideDirection
    this.slideDirection = null;
    this.lastSlideDirection = null;
    this.slideRight = 'slide-right';
    this.slideLeft = 'slide-left';
    this.noSlide = null;
    this.pendingForward = null;

    // initialize state
    this.state = {
      /* keep track of the tiers selected.  if top tier, this is an
       * empty array.
       */
      tiers: []
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.performSelect = this.performSelect.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleToTier = this.handleToTier.bind(this);
    this.forward = this.forward.bind(this);
  }

  /**
   * The main logic here focuses on ensuring that if options for
   * a tier were updated that they are reflected in the UI.
   * Previously, if an option was added the UI would only update
   * when changing the tiers.
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    const tiers = prevState.tiers;
    const newTiers = JSON.parse(JSON.stringify(tiers));
    const currentTier = newTiers[newTiers.length - 1];
    // Copy the incomming data and loop through the previous tiers until
    // the data (options) are looking at the same set of options.
    let next = JSON.parse(JSON.stringify(nextProps.data));
    newTiers.forEach(tier => {
      if (next) {
        const found = next.find(child => child.id === tier.id);
        next = found ? found.nodes : [];
      }
    });
    // If there's a change in the amount of options we should display
    // then update the state to reflect the _new_ options.
    if (currentTier && next) {
      currentTier.nodes = next;
      return {
        tiers: newTiers
      };
    }
    return {};
  }

  /**
   *  given an id, return the related object
   */
  getOptionFromId(id) {
    let incomingTierData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const data = this.props.data;
    let tierData = _.clone(incomingTierData);
    if (_.isNull(tierData)) {
      tierData = data;
    }
    let result = null;
    const ix = _.findIndex(tierData, option => option.id === id);
    if (ix === -1) {
      // not on this tier - try searching children.
      for (let i = 0; i < tierData.length; i += 1) {
        const children = tierData[i].nodes;
        if (children) {
          const tmp = this.getOptionFromId(id, children);
          if (tmp !== null) {
            result = tmp;
            break;
          }
        }
      }
    } else {
      result = tierData[ix];
    }
    return result;
  }

  /**
   *  figure out if we are sliding right, left or static
   */
  getSliderClassNames() {
    let result = '';
    if (this.slideDirection !== null) {
      result = this.slideDirection;
    }
    if (this.slideDirection === this.lastSlideDirection) {
      result += '-force';
    }
    // save the last slide so we know if we need to 'force' next time.
    this.lastSlideDirection = result;
    return result;
  }
  getValuesAsObjects() {
    const value = this.props.value;
    const list = [];
    for (let i = 0, len = value.length; i < len; i += 1) {
      // if it's an object, assume that it has an id key.
      if (_.isObject(value[i])) {
        list.push(value[i]);
      } else {
        list.push(this.getOptionFromId(value[i]));
      }
    }
    return list;
  }
  displayOptionsForTier() {
    const _this$props = this.props,
      data = _this$props.data,
      onTierDown = _this$props.onTierDown,
      showChevron = _this$props.showChevron;
    const tiers = this.state.tiers;

    // this first check is to see if we need to move forward.
    if (!_.isNull(this.pendingForward)) {
      this.forward(this.pendingForward);
      return '';
    }
    const tierNum = tiers.length;
    let result = null;
    if (data && data.length > 0) {
      let options = data;
      for (let i = 0; i < tierNum; i += 1) {
        const tier = tiers[i];
        if (tier.nodes) {
          options = JSON.parse(JSON.stringify(tier.nodes));
        }
      }
      result = [];
      _.each(options, option => {
        // There are several states that will affect a given option.

        // show the checkbox checked if one of the following is true:
        //   1) is this option selected?
        //   2) one ore any of its children selected

        // show the children navigation info icon and caret on the right if:
        //   1) it has children AND
        //   2) the option is selected OR any of its children are selected
        const optionForward = () => {
          if (onTierDown) {
            onTierDown(option);
          }
          this.forward(option);
        };
        let chevron = null;
        if (showChevron) {
          chevron = /*#__PURE__*/React.createElement("div", {
            "aria-label": "tiered-select-right",
            tabIndex: 0,
            role: "link",
            style: {
              marginLeft: '10px',
              position: 'relative',
              top: '-20px',
              outline: 'none'
            },
            onClick: optionForward,
            onKeyPress: optionForward,
            className: "float-md-right fade-in t-ts-chevron"
          }, /*#__PURE__*/React.createElement(Icon, {
            glyph: "angle-right"
          }));
        }
        const label = option.name;
        const selectedChildren = this.selectedChildren(option);
        const checkboxProps = {
          className: "t-ts-option t-ts-option-".concat(kebabCase(option.name)),
          checked: false,
          // width: '100%',
          key: "chk-".concat(option.id),
          onChange: this.handleSelect.bind(this, option)
        };
        const hasChildren = option.nodes && option.nodes.length > 0;
        if (this.isSelected(option) || selectedChildren.length > 0) {
          checkboxProps.checked = true;
        }
        result.push(/*#__PURE__*/React.createElement("div", {
          key: "div-".concat(option.id)
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormGroup, {
          check: true
        }, /*#__PURE__*/React.createElement(Label, {
          check: true
        }, /*#__PURE__*/React.createElement(Input, _extends({
          type: "checkbox"
        }, checkboxProps)), ' ', label)), hasChildren && checkboxProps.checked ? /*#__PURE__*/React.createElement("div", {
          role: "link",
          "aria-label": "tiered-select-select-children",
          tabIndex: 0,
          style: {
            // seems like there might be a better way?
            marginLeft: '10px',
            position: 'relative',
            top: '-20px',
            outline: 'none'
          },
          onClick: optionForward,
          onKeyPress: optionForward,
          className: "float-md-right fade-in t-ts-forward t-ts-forward-".concat(kebabCase(label))
        }, /*#__PURE__*/React.createElement(Icon, {
          glyph: "info-circle"
        }), /*#__PURE__*/React.createElement(Icon, {
          glyph: "angle-right"
        })) : null, hasChildren && !checkboxProps.checked ? chevron : null, /*#__PURE__*/React.createElement("div", null, hasChildren && selectedChildren.length !== option.nodes.length ? _.pluck(selectedChildren, 'name').join(',') : undefined)), /*#__PURE__*/React.createElement("hr", null)));
      });
    }
    return result;
  }

  /**
   *  this will take you UP the hierarchy one tier.
   */
  handleBack() {
    const tiers = this.state.tiers;
    const _this$props2 = this.props,
      onBack = _this$props2.onBack,
      onTieredBack = _this$props2.onTieredBack;
    let newTiers;

    // moving UP the tree, so slide right.
    this.slideDirection = this.slideRight;
    if (tiers.length === 0) {
      onBack();
    } else {
      newTiers = JSON.parse(JSON.stringify(tiers));
      newTiers.pop();
      this.setState({
        tiers: newTiers
      });
    }
    if (onTieredBack) {
      onTieredBack(newTiers);
    }
  }

  /**
   *  this will take you UP the hierarchy to the specified option. This is used in
   *  breadcrumb navigation so you can skip up several tiers at once.
   */
  handleToTier(option) {
    const tiers = this.state.tiers;

    // always means moving up the hierarchy, so slide right
    this.slideDirection = this.slideRight;
    const result = [];
    for (let i = 0; i < tiers.length; i += 1) {
      const tier = tiers[i];

      // if this is the selected tier, don't go any further
      if (tier.id === option.id) {
        break;
      }
      result.push(tier);
    }
    this.setState({
      tiers: result
    });
    return result;
  }

  /**
   *  one of the options was selected.  This could be to add it to the values, or remove it if
   *  already added.
   */
  performSelect(option) {
    const _this$props3 = this.props,
      autoForward = _this$props3.autoForward,
      keepParent = _this$props3.keepParent,
      multi = _this$props3.multi,
      nestParents = _this$props3.nestParents,
      onChange = _this$props3.onChange,
      selectChildren = _this$props3.selectChildren;
    let values = option;

    /* this is the case where we want to immediately navigate down to
       the next level.
     */
    if (autoForward && option.nodes && option.nodes.length > 0) {
      return this.forward(option);
    }
    if (multi) {
      values = this.getValuesAsObjects();
      if (this.isSelected(option) || this.hasSelectedChildren(option)) {
        values = _.filter(values, elem => elem.id !== option.id);
        // get any children of this node that are selected & remove them too.
        this.selectedChildren(option).forEach(child => {
          values = _.filter(values, elem => elem.id !== child.id);
        });

        /* we need to add back in the direct parent of this child (if any),
         * if there are no siblings still selected.  we check for 1 child
         * selected because we have not yet removed the current child....
         */
        const parent = this.parent(option);
        if (!_.isNull(parent)) {
          if (this.selectedChildren(parent).length <= 1) {
            values.push(parent);
          }
        }
      } else {
        const parent = this.parent(option);

        // remove parent from filter if not specifically noted
        if (!keepParent && parent) {
          values = _.filter(values, value => value.id !== parent.id);
        }
        if (values) {
          values.push(option);
        } else {
          values = option;
        }
      }
    } else {
      // set new value
      values = [option];
    }
    let newValues = values;
    const parent = this.parent(option);
    if (selectChildren && _.isNull(parent)) {
      /* this means we have selected/deselected a parent.
       *  if (option.hasSelectedChildren) {
       *     ...deselect all children...
       *  }  else {
       *     ...select all children...
       *  }
       */

      // any selected children?
      if (this.hasSelectedChildren(option)) {
        // remove all the children
        newValues = _.filter(values, value => option.nodes.some(child => child.id === value.id) !== true);
      } else {
        // add all children
        // okay this value if it is NOT one of the children.
        option.nodes.forEach(child => {
          if (newValues.some(value => child.id === value.id) !== true) {
            // not already in list
            newValues.push(child);
          }
        });
      }

      // only keep entities that are not same as parent.
      newValues = _.filter(newValues, value => value.entity !== option.entity);
    }

    // store newValues to preserve the nested children for rendering
    let copyValues = newValues.map(val => {
      const copyVal = _.clone(val);
      if (!_.isEmpty(copyVal.nodes)) {
        copyVal.nodes = [];
      }
      return copyVal;
    });

    // created for use by OptionNestedSinglePicker
    if (nestParents) {
      const nestedParents = this.nestParents(option);
      copyValues = nestedParents;

      // unselects the option and clears the selected list.
      if (this.isSelected(option)) {
        return true;
      }
    }
    onChange(copyValues, option);
    return true;
  }

  // created for use by OptionNestedSinglePicker
  // which nests children under a children property
  // instead of a node property.
  nestParents(option) {
    const nestOption = JSON.parse(JSON.stringify(option));
    const newParent = this.parent(nestOption);
    if (_.isNull(newParent)) {
      return [nestOption];
    }
    delete newParent.nodes;
    newParent.children = nestOption;
    return this.nestParents(newParent);
  }
  handleSelect(option) {
    const handlePreSelect = this.props.handlePreSelect;
    if (handlePreSelect) {
      handlePreSelect(option, this.performSelect, this.forward);
      return true;
    }
    this.performSelect(option);
    return true;
  }
  hasSelectedChildren(option) {
    return this.selectedChildren(option).length > 0;
  }

  /**
   *  this will take you DOWN the hierarchy one tier to the option selected.
   */
  forward(option) {
    const tiers = this.state.tiers;
    // erase any pending forwards...
    this.pendingForward = null;
    // moving DOWN the tree, so slide right
    this.slideDirection = this.slideLeft;
    const newTiers = tiers.slice();
    newTiers.push(option);
    this.setState({
      tiers: newTiers
    });
    return false;
  }
  isSelected(node) {
    let result = false;
    const values = this.getValuesAsObjects();
    if (values && values.length > 0) {
      _.each(values, value => {
        if (value.id === node.id) {
          result = true;
        }
      });
    } else if (values === node.id) {
      result = true;
    }
    return result;
  }
  parent(option) {
    let incomingTierData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const data = this.props.data;
    let tierData = incomingTierData;
    if (_.isNull(tierData)) {
      tierData = data;
    }
    let result = null;
    const ix = _.findIndex(tierData, opt => opt.id === option.id);
    if (ix === -1) {
      // not on this tier - try searching children.
      for (let i = 0; i < tierData.length; i += 1) {
        const children = tierData[i].nodes;
        if (children) {
          const tmp = this.parent(option, children, tierData[i]);
          if (tmp !== null) {
            result = tmp;
            break;
          }
        }
      }
    } else {
      result = parent;
    }
    return result;
  }

  /**
   *  this returns a list of children that have been selected for an item.
   */
  selectedChildren(option) {
    let result = [];
    if (option.nodes) {
      _.each(option.nodes, node => {
        if (this.isSelected(node)) {
          result.push(node);
        }
        result = result.concat(this.selectedChildren(node));
      });
    }
    return result;
  }
  render() {
    const tiers = this.state.tiers;
    const _this$props4 = this.props,
      backLabel = _this$props4.backLabel,
      children = _this$props4.children,
      label = _this$props4.label,
      onBack = _this$props4.onBack;

    // after getting classNames, clear out direction for next render.
    this.slideDirection = this.noSlide;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, label), onBack || tiers.length > 0 ? /*#__PURE__*/React.createElement(BreadcrumbsBack, {
      onBack: this.handleBack,
      onSelect: this.handleToTier,
      tiers: tiers,
      backLabel: backLabel
    }) : undefined, children, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: "animation-wrapper tiered-entity-select"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxHeight: '50vh',
        overflowX: 'scroll'
      },
      className: this.getSliderClassNames()
    }, this.displayOptionsForTier())));
  }
}
TieredSelect.propTypes = {
  /* this property instructs the entity to
   *  use parent options a selectors of all
   *  children instead of options themselves
   */
  selectChildren: PropTypes.bool,
  autoForward: PropTypes.bool,
  multi: PropTypes.bool,
  showBack: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  label: PropTypes.string,
  nestParents: PropTypes.bool,
  // created for use by OptionNestedSinglePicker
  onChange: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  onTieredBack: PropTypes.func,
  onTierDown: PropTypes.func,
  keepParent: PropTypes.bool,
  backLabel: PropTypes.string,
  children: PropTypes.node,
  showChevron: PropTypes.bool,
  // Callback that interrupts the select event
  handlePreSelect: PropTypes.func
};
TieredSelect.defaultProps = {
  showChevron: false,
  autoForward: false,
  backLabel: 'Filters',
  children: null,
  keepParent: false,
  label: null,
  multi: true,
  nestParents: false,
  // created for use by OptionNestedSinglePicker
  onBack: null,
  onTieredBack: null,
  onTierDown: null,
  handlePreSelect: null,
  selectChildren: false,
  showBack: true,
  value: []
};